import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import {
  EventLimit,
  VERIFIED_LIMIT,
} from "components/manualReview/filters/eventFilters";
import { useTenantTranslation } from "hooks/formatters";

const ALL = "all" as const;

export const LimitToggle = ({
  limitTo,
  onChange,
}: {
  limitTo: EventLimit | null;
  onChange: (limitTo: EventLimit | null) => void;
}) => {
  const { t } = useTenantTranslation();
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={limitTo ?? ALL}
      onChange={(_, value: typeof ALL | EventLimit | null) => {
        if (value !== null) onChange(value === ALL ? null : value);
      }}
    >
      <ToggleButton value={ALL}>{t("all")}</ToggleButton>
      <ToggleButton value={VERIFIED_LIMIT}>{t("verifiedOnly")}</ToggleButton>
    </ToggleButtonGroup>
  );
};
